// extracted by mini-css-extract-plugin
export default {"label":"form_label__BQujv","input":"form_input__S06Rp","textarea":"form_textarea__0J3Ce","formGoup":"form_formGoup__hFX7U","upload":"form_upload__q11qS","form":"form_form__vWt4F"};